import { BaseFetch } from "../main-model"
export default class ReportConstructionInfoModel extends BaseFetch {
  getReportConstructionInfoBy = (data) =>
    this.authFetch({
      url: "report-construction-info/getReportConstructionInfoBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportConstructionInfoYear = (data) =>
    this.authFetch({
      url: "report-construction-info/getReportConstructionInfoYear",
      method: "POST",
      body: JSON.stringify(data),
    })

}
